import { render, staticRenderFns } from "./NoMessages.vue?vue&type=template&id=7e532927&scoped=true"
import script from "./NoMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoMessages.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NoMessages.vue?vue&type=style&index=0&id=7e532927&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e532927",
  null
  
)

export default component.exports